export const LOAD: 'PROGRAM_OVERVIEW/LOAD' = 'PROGRAM_OVERVIEW/LOAD';
export const LOAD_SUCCESS: 'PROGRAM_OVERVIEW/LOAD/SUCCESS' = 'PROGRAM_OVERVIEW/LOAD/SUCCESS';
export const LOAD_FAILURE: 'PROGRAM_OVERVIEW/LOAD/FAILURE' = 'PROGRAM_OVERVIEW/LOAD/FAILURE';
export const SET_LOADING_STATE: 'PROGRAM_OVERVIEW/LOAD/SET_LOADING_STATE' = 'PROGRAM_OVERVIEW/LOAD/SET_LOADING_STATE';
